import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const Support = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-16">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                        Support & Donations
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Your generous support helps us spread the Gospel, provide essential services, and make lasting impact in our communities.
                    </p>
                </div>

                <Card className="border-none shadow-lg">
                    <CardHeader>
                        <CardTitle className="text-2xl text-purple-700">Why Your Support Matters</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4 text-gray-700 leading-relaxed">
                        <p>
                            As a Diocese, we are committed to advancing God’s kingdom on earth through worship, education, healthcare, and outreach. Your financial support enables us to:
                        </p>
                        <ul className="list-disc pl-6 space-y-1">
                            <li>Fund mission and evangelism initiatives.</li>
                            <li>Support clergy and diocesan staff.</li>
                            <li>Maintain church infrastructure and properties.</li>
                            <li>Run health and wellness programs including mobile clinics.</li>
                            <li>Provide scholarships and education grants.</li>
                            <li>Empower youth and community programs.</li>
                        </ul>
                    </CardContent>
                </Card>

                <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Card className="border-none shadow-md">
                        <CardHeader>
                            <CardTitle className="text-xl text-purple-700">Bank Transfer (Current Account)</CardTitle>
                        </CardHeader>
                        <CardContent className="text-gray-700 space-y-2">
                            <p><strong>Bank:</strong> First Bank Nigeria</p>
                            <p><strong>Account Name:</strong> Ibadan South Diocese</p>
                            <p><strong>Account Number:</strong> 2001017784</p>
                            <p><strong>Account Type:</strong> Current</p>
                        </CardContent>
                    </Card>

                    <Card className="border-none shadow-md">
                        <CardHeader>
                            <CardTitle className="text-xl text-purple-700">Bank Transfer (Savings Account)</CardTitle>
                        </CardHeader>
                        <CardContent className="text-gray-700 space-y-2">
                            <p><strong>Bank:</strong> First Bank Nigeria</p>
                            <p><strong>Account Name:</strong> Ibadan South Diocese</p>
                            <p><strong>Account Number:</strong> 3017518067</p>
                            <p><strong>Account Type:</strong> Savings</p>
                        </CardContent>
                    </Card>
                </div>

                <div className="mt-12 text-center">
                    <p className="text-xl font-semibold text-purple-700">
                        “Each of you should give what you have decided in your heart to give,
                        not reluctantly or under compulsion, for God loves a cheerful giver.”
                    </p>
                    <p className="mt-2 text-gray-600 italic">— 2 Corinthians 9:7</p>
                </div>
            </div>
        </div>
    );
};

export default Support;
